export default __webpack_public_path__ + "static/media/098.ac9362a0.jpg";